import { Hidden } from "@material-ui/core";
import React, { useEffect } from "react";
import CarouselCtaButton from "./CarouselCtaButton";
import CarouselTextContent from "./CarouselTextContent";
import {makeStyles} from "@material-ui/core/styles"
import CarouselCountdownTimer from './CarouselCountdownTimer';
import { LargeBusiness } from "../../Constants";

function TextDescription({onRemoveCDT, textContent, countdownTimer, ctaButton, isAlignCenter, foregroundCondition   }) {
  
// Center Align if No-Foreground using makestyle.
  // let centerAlignmentStyle = isAlignCenter ? {
  //   margin:"0 !important",
  //   flex:"1 !important",
  //   alignItems: "center !important",
  //   maxWidth:"1250px !important"
  // } : {} 
  
  // let containerStyle = makeStyles({
  //   root:{      
  //     ...centerAlignmentStyle
  //   }
  // })

  useEffect(() => {
    const allCtaBtn = document.querySelectorAll(".carousel-cta-button .btn");
    const setTabIndex = (element) => {
      if(element!= null){
       element.setAttribute("tabindex", 0);
       element.className.indexOf("cta-video-btn") >= 0 && element.setAttribute("href", "#");
      }
    };
    
    Array.from(allCtaBtn).map((element) => setTabIndex(element));
  }, [])
  const classes = isAlignCenter? "text-content-center-align" : " "
  const lbCarousel = LargeBusiness.isLBSite ? "carousel-lb-slide-des" :""

  //const isCountdownTimer = countdownTimer!=undefined ?( (new Date(countdownTimer.timerDateTime) - new Date()) >= 0 ? true : false ): false
  let isCountdownTimer = false;

  if(countdownTimer!=undefined){
    if((new Date(parseInt(countdownTimer.timerDateTime)) - new Date()) >= 0){
      isCountdownTimer= true;
  
    }
  }

  return (
    <div className={`carousel-slide-description ${lbCarousel} ` + classes}>
      {/* text element */}
      <CarouselTextContent textContent={textContent} isAlignCenter={isAlignCenter}/>

      {/* counttimer */}
      
      {
       isCountdownTimer ? <div className="carousel-description-countdowntimer">
          <CarouselCountdownTimer className="responsive-carousel-timer-container" onRemoveCDT={onRemoveCDT} timerContent={countdownTimer}/>
          </div>:""
        }
      
      

      {/* cta button */}
      {
        (ctaButton!=undefined) && <div className="carousel-slide-cta-container">
        {
          ctaButton.map((ctaprop,i) => i==0 ?   
          <CarouselCtaButton 
          cta={ctaprop} 
          isAlignCenter={isAlignCenter} 
          key={i}

          /> : 
          //hides the buttons other than the first one below 600px screen width
          <Hidden key={i} xsDown><CarouselCtaButton cta={ctaprop} isAlignCenter={isAlignCenter}/></Hidden>
          )
                }
          </div>
          }

          {/* terms & condition */}
          
            {/* <div className="terms" style={{width:"583px",marginTop:"62px"}}>
             <p className="terms-para" style={{fontFamily:"gt-walsheim-regular",fontSize:"10px",lineHeight:"12px",color:"white"}}>Based on analysis by Ookla® of Speedtest Intelligence® 5G availability data in Ireland Q2 2021. Ookla trademarks used under license and reprinted with permission.</p>
            </div> */}
           
                
    </div>
  );
}

export default TextDescription;
